import React, { useEffect, createElement } from 'react';
import { MapPinIcon, ArrowRightIcon } from 'lucide-react';
import { FinalCtaSection } from '../components/FinalCtaSection';
const regions = [{
  name: 'Kop van Noord-Holland',
  cities: [{
    name: 'Den Helder',
    slug: 'den-helder'
  }, {
    name: 'Texel',
    slug: 'texel'
  }, {
    name: 'Hollands Kroon',
    slug: 'hollands-kroon'
  }, {
    name: 'Schagen',
    slug: 'schagen'
  }]
}, {
  name: 'Noord-Holland Noord',
  cities: [{
    name: 'Alkmaar',
    slug: 'alkmaar'
  }, {
    name: 'Heerhugowaard',
    slug: 'heerhugowaard'
  }, {
    name: 'Dijk en Waard',
    slug: 'dijk-en-waard'
  }, {
    name: 'Bergen',
    slug: 'bergen'
  }]
}, {
  name: 'Kennemerland',
  cities: [{
    name: 'Heiloo',
    slug: 'heiloo'
  }, {
    name: 'Castricum',
    slug: 'castricum'
  }, {
    name: 'Uitgeest',
    slug: 'uitgeest'
  }]
}, {
  name: 'West-Friesland',
  cities: [{
    name: 'Hoorn',
    slug: 'hoorn'
  }, {
    name: 'Enkhuizen',
    slug: 'enkhuizen'
  }, {
    name: 'Medemblik',
    slug: 'medemblik'
  }, {
    name: 'Stede Broec',
    slug: 'stede-broec'
  }, {
    name: 'Drechterland',
    slug: 'drechterland'
  }, {
    name: 'Koggenland',
    slug: 'koggenland'
  }, {
    name: 'Opmeer',
    slug: 'opmeer'
  }]
}, {
  name: 'IJmond',
  cities: [{
    name: 'Velsen',
    slug: 'velsen'
  }, {
    name: 'Beverwijk',
    slug: 'beverwijk'
  }, {
    name: 'Heemskerk',
    slug: 'heemskerk'
  }]
}, {
  name: 'Zuid-Kennemerland',
  cities: [{
    name: 'Haarlem',
    slug: 'haarlem'
  }, {
    name: 'Bloemendaal',
    slug: 'bloemendaal'
  }, {
    name: 'Zandvoort',
    slug: 'zandvoort'
  }, {
    name: 'Heemstede',
    slug: 'heemstede'
  }]
}, {
  name: 'Zaanstreek-Waterland',
  cities: [{
    name: 'Zaanstad',
    slug: 'zaanstad'
  }, {
    name: 'Purmerend',
    slug: 'purmerend'
  }, {
    name: 'Edam-Volendam',
    slug: 'edam-volendam'
  }, {
    name: 'Waterland',
    slug: 'waterland'
  }, {
    name: 'Landsmeer',
    slug: 'landsmeer'
  }, {
    name: 'Oostzaan',
    slug: 'oostzaan'
  }, {
    name: 'Wormerland',
    slug: 'wormerland'
  }]
}, {
  name: 'Amstelland-Meerlanden',
  cities: [{
    name: 'Haarlemmermeer',
    slug: 'haarlemmermeer'
  }, {
    name: 'Amstelveen',
    slug: 'amstelveen'
  }, {
    name: 'Aalsmeer',
    slug: 'aalsmeer'
  }, {
    name: 'Uithoorn',
    slug: 'uithoorn'
  }, {
    name: 'Ouder-Amstel',
    slug: 'ouder-amstel'
  }, {
    name: 'Diemen',
    slug: 'diemen'
  }]
}, {
  name: 'Groot-Amsterdam',
  cities: [{
    name: 'Amsterdam',
    slug: 'amsterdam'
  }]
}, {
  name: 'Gooi en Vechtstreek',
  cities: [{
    name: 'Hilversum',
    slug: 'hilversum'
  }, {
    name: 'Huizen',
    slug: 'huizen'
  }, {
    name: 'Gooise Meren',
    slug: 'gooise-meren'
  }, {
    name: 'Blaricum',
    slug: 'blaricum'
  }, {
    name: 'Laren',
    slug: 'laren'
  }, {
    name: 'Wijdemeren',
    slug: 'wijdemeren'
  }]
}];
export function AlleLocatiesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Alle locaties | Webdesign Noord-Holland | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Webdesign in heel Noord-Holland. Bekijk alle 40 gemeenten waar Noord Digital professionele websites bouwt. Van Texel tot Amsterdam, van Alkmaar tot Hilversum.';
    // Open Graph meta tags
    const ogTags: Record<string, string> = {
      'og:title': 'Alle locaties | Webdesign Noord-Holland | Noord',
      'og:description': 'Webdesign in heel Noord-Holland. Bekijk alle 40 gemeenten waar Noord Digital professionele websites bouwt.',
      'og:type': 'website',
      'og:url': 'https://noorddigital.nl/alle-locaties',
      'og:site_name': 'Noord Digital',
      'og:locale': 'nl_NL'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  return <main className="pt-16 lg:pt-[72px]" data-id="element-1039" data-mp="cpq5oc8ltcsf">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-1040" data-mp="cru9yvaf0dt8">
        {/* Background decorative elements */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-1041" data-mp="2zy8da94e5k9">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-1042" data-mp="2y3n1utxsbfn" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-1043" data-mp="vghf1dsld36t" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-1044" data-mp="qp96sl2zznv8" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1045" data-mp="2b832tfzadc43">
          <p className="text-accent-light font-semibold text-sm tracking-widest uppercase mb-4 animate-fade-in-up" data-id="element-1046" data-mp="2g6winf21pf7f">
            Lokaal Webdesign
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 animate-fade-in-up-delay-1" data-id="element-1047" data-mp="225k5fbe9rrp8">
            Webdesign in heel Noord-Holland
          </h1>
          <p className="text-lg lg:text-xl text-navy-200 max-w-2xl mx-auto animate-fade-in-up-delay-2" data-id="element-1048" data-mp="1sa0n5rsmoriy">
            Wij bouwen professionele, conversiegerichte websites voor
            ondernemers in de hele provincie. Vind jouw regio en ontdek wat we
            voor jou kunnen betekenen.
          </p>
        </div>
      </section>

      {/* Regions Section */}
      <section className="py-24 bg-surface-muted" data-id="element-1049" data-mp="1fypv9uwd25vf">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1050" data-mp="1fz9av4yjgi6a">
          <div className="space-y-16" data-id="element-1051" data-mp="1b05049vyucdu">
            {regions.map(region => <div key={region.name} data-id="element-1052" data-mp="1po9bstwlpnn4">
                <h2 className="text-2xl font-bold text-navy-900 mb-6 border-b border-navy-100 pb-4" data-id="element-1053" data-mp="1ppb0402mo6ms">
                  {region.name}
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-1054" data-mp="1yp7g7daybx68">
                  {region.cities.map(city => <a key={city.slug} href={`#/webdesign-${city.slug}`} className="group flex items-center justify-between bg-white p-5 rounded-card shadow-sm hover:shadow-medium border border-transparent hover:border-accent/20 transition-all duration-300" data-id="element-1055" data-mp="1un2quqrjdmpe">
                      <div className="flex items-center gap-3" data-id="element-1056" data-mp="9a9hpzkfss7s">
                        <div className="w-8 h-8 rounded-lg bg-navy-50 group-hover:bg-accent-light flex items-center justify-center transition-colors" data-id="element-1057" data-mp="9c3zj50ew47n">
                          <MapPinIcon className="w-4 h-4 text-navy-400 group-hover:text-accent transition-colors" data-id="element-1058" data-mp="3ol2qs4h16weo" />
                        </div>
                        <span className="font-medium text-navy-900 group-hover:text-accent transition-colors" data-id="element-1059" data-mp="3td2ywk798vmc">
                          {city.name}
                        </span>
                      </div>
                      <ArrowRightIcon className="w-4 h-4 text-navy-300 group-hover:text-accent group-hover:translate-x-1 transition-all" data-id="element-1060" data-mp="30pqd4c8x4ru3" />
                    </a>)}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <FinalCtaSection data-id="element-1061" data-mp="3fitkjqsspp73" />
    </main>;
}